import React from 'react';
import { Radio } from '../Radio';
import { IItemType, ISmartProps } from './types';
import { View } from './view';

export type RadioGroupProps = Omit<ISmartProps, 'css'>;

export const RadioGroup = React.forwardRef((props: RadioGroupProps, ref: any) => {
	const { items, ...rest } = props;
	return (
		<View {...rest} ref={ref}>
			{items &&
				items.map((item: IItemType, _index: number) => (
					<Radio key={_index} size={props.size} {...item}>
						{item.label}
					</Radio>
				))}
			{props.children}
		</View>
	);
});
